import React from "preact/compat";

interface Props {
  data: string;
}

export const Odds: React.FunctionComponent<Props> = ({
  data
}) => {  
    return (
      <span>
        {data !== '' ?
          <span className="d-inline-block me-2">
              <b className="pe-1">
                {data.split(' ')[0]}
              </b>
            {data.split(' ')[1] ? 
              <span className="text-gray">
                {data.split(' ')[1]}
              </span>
            : ""}
          </span>
        : '' }
    </span>
    )
};